//Tooltips

const ACTIVE_HELP_MODE = "Kατάσταση βοήθειας ενεργή."
const HELP_MODE = "Κατάσταση βοήθειας."
const HOME = "Μετάβαση στο αρχικό μενού"

//pdf controls
const START_PAGE = "Σας μεταφέρει στην πρώτη σελίδα του βιβλίου."
const END_PAGE = "Σας μεταφέρει στην τελευταία σελίδα του βιβλίου."
const NEXT_PAGE = "Σας μεταφέρει στην επόμενη σελίδα του βιβλίου."
const PREV_PAGE = "Σας μεταφέρει στην προηγούμενη σελίδα του βιβλίου."
const CURR_PAGE = ""
const AUTO_PLAY = "Δίνει την δυνατότητα συνεχούς διαδοχικής ροής (ή διακοπής) ανάγνωσης και θέασης του κειμένου της σελίδας στην ΕΝΓ."
const FULL_SCRN = "Μεγαλώνει την σελίδα του βιβλίου και επαναφέρει την σελίδα του βιβλίου σου στο κανονικό της μέγεθος."

//video player
const VIDEO_PLAY = "Θέτει σε λειτουργία το βίντεο."
const VIDDEO_PAUSE = "Διακόπτει προσωρινά (παύει) τη λειτουργία του βίντεο."
const VIDEO_INCREASE_PLAYBACK = "Κάνει την ταχύτητα του βίντεο πιο γρήγορη από την κανονική."
const VIDEO_DECREASE_PLAYBACK = "Κάνει την ταχύτητα του βίντεο πιο αργή από την κανονική."
const VIDEO_PLAYBACK_SPEED = ""
const VIDEO_SNAP = "Δίνει τη δυνατότητα λήψης μιας φωτογραφίας (καρέ) από το βίντεο."
const VIDEO_SUBS = "Επιτρέπει να εμφανίζονται υπότιτλοι στο βίντεο."
const VIDEO_VOL = ""
const VIDEO_MUTE = "Ενεργοποιεί ή απενεργοποιεί την ένταση του ήχου."
const VIDEO_FULL_SCRN = "Προβάλει το βίντεο σε πλήρη οθόνη."


export {
    ACTIVE_HELP_MODE,
    HELP_MODE,
    HOME,
    START_PAGE,
    END_PAGE,
    NEXT_PAGE,
    PREV_PAGE,
    CURR_PAGE,
    AUTO_PLAY,
    FULL_SCRN,
    VIDEO_PLAY,
    VIDDEO_PAUSE,
    VIDEO_INCREASE_PLAYBACK,
    VIDEO_DECREASE_PLAYBACK,
    VIDEO_PLAYBACK_SPEED,
    VIDEO_SNAP,
    VIDEO_SUBS,
    VIDEO_VOL,
    VIDEO_MUTE,
    VIDEO_FULL_SCRN,
}